module.exports = "<div *ngIf=\"this.router.url === '/login'; else showNav\">\r\n\r\n</div>\r\n\r\n\r\n<!-- <div *ngIf=\"isLoggedIn$ | async as isLoggedIn; else showNav\">\r\n  <app-nav [hidden]=\"this.router.url === '/login'\"></app-nav>\r\n</div> -->\r\n\r\n<ng-template #showNav>\r\n \r\n<app-nav></app-nav>\r\n\r\n</ng-template>\r\n<router-outlet></router-outlet>\r\n\r\n\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = ./src/app/app.component.html
// module chunks = main